import { render, staticRenderFns } from "./HomeDepois.vue?vue&type=template&id=2475cc57&scoped=true"
import script from "./HomeDepois.vue?vue&type=script&lang=js"
export * from "./HomeDepois.vue?vue&type=script&lang=js"
import style0 from "./HomeDepois.vue?vue&type=style&index=0&id=2475cc57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2475cc57",
  null
  
)

export default component.exports